import axios from "axios";
import {
    SET_LOADER,
    CATCH_ERROR,
    FETCH_APPLICTION,
    DELETE_APPLICATION,
    GET_APPLICATION_DETAIL,
    RESET_APPLICATION,
    UPDATE_APPLICATION,
    RESET_ACTION,
    OWNERS_LIST,
    ADD_OWNER,
    REMOVE_OWNER,

    CATCH_ERROR_APPS
} from "./type";
import { API_PATHS, bearerToken } from "./constants";

export const setLoader = (loader) => (dispatch) => {
    dispatch({ type: SET_LOADER, payload: loader })
}

export const resetAction = () => (dispatch) => {
  dispatch({ type: RESET_ACTION, payload: {} });
};

  export const fetchApplicationsList = (organizationId, gateway, authType, currentPage, pageSize, searchTxt, assetId, versionGroup) => {
    const addOrgId = organizationId ? `/organizations/${organizationId}` : '';
    const gateWayParam = gateway ? `&gateway=${gateway}` : '';
    const authTypeParam = authType ? `&authType=${authType}` : '';
    const addAssetAndVersion = (assetId && versionGroup) 
    ? `&assetId=${assetId}&version=${versionGroup}` 
    : ''; 
    return (dispatch) => {
      return axios
        .get(`${API_PATHS.REQUEST_PAGE_API}${addOrgId}/applications${addOrgId ? "/" : ""}?page=${currentPage}&size=${pageSize}&searchText=${searchTxt}${addAssetAndVersion}${gateWayParam}${authTypeParam}`)
        .then((res) => {
          dispatch({
            type: FETCH_APPLICTION,
            payload: {
              data: res.data,
              status: true
            },
          })
        })
        .catch((err) => {
          dispatch({ type: CATCH_ERROR_APPS, payload: { data: err.response?.data, status: false }})
        })
    }
  }

  export const updateApplicationDetail = (organizationId, appId, updatedData) => {
    return (dispatch) => {
      return axios
        .patch(`${API_PATHS.REQUEST_PAGE_API}/${organizationId}/applications/${appId}`, {...updatedData})
        .then((res) => {
          dispatch({
            type: UPDATE_APPLICATION,
            payload: {
              data: res.data,
            },
          })
        })
        .catch((err) => {
          dispatch({ type: CATCH_ERROR_APPS, payload: { data: err.response?.data, status: false }})
        })
    }
  }

  export const resetSecretApplication = (organizationId, gateway, authType, appId, callback=null, errorCallback=null) => {
    const addOrgId = organizationId ? `/organizations/${organizationId}` : '';
    const gateWayParam = gateway ? `&gateway=${gateway}` : '';
    const authTypeParam = authType ? `&authType=${authType}` : '';
    return (dispatch) => {
      return axios
        .post(`${API_PATHS.REQUEST_PAGE_API}${addOrgId}/applications/${appId}/secret/reset?${gateWayParam}${authTypeParam}`)
        .then((res) => {
            console.log("fetch_request ",res);
          dispatch({
            type: RESET_APPLICATION,
            payload: {
              status: true,
              data: res.data,
            },
          })
          if(callback) {
            callback(res.data);
          }
        })
        .catch((err) => {
          const errorData = err.response?.data;
          dispatch({ type: CATCH_ERROR_APPS, payload: { data: errorData, status: false }})
          if (errorCallback) {
            errorCallback(errorData);
          }
        })
    }
  }

  export const deleteApplicationDetail = (organizationId, gateway, authType, appId) => {
    const addOrgId = organizationId ? `/organizations/${organizationId}` : '';
    const gateWayParam = gateway ? `&gateway=${gateway}` : '';
    const authTypeParam = authType ? `&authType=${authType}` : '';
    return (dispatch) => {
      return axios
        .delete(`${API_PATHS.REQUEST_PAGE_API}${addOrgId}/applications/${appId}?${gateWayParam}${authTypeParam}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        .then((res) => {
            console.log("delete_request ",res);
            dispatch({ type: DELETE_APPLICATION, payload: { data: {
              message: "Deleted Successfully"
            }, status: true }})
        })
        .catch((err) => {
          dispatch({ type: CATCH_ERROR_APPS, payload: { data: err.response?.data, status: false }})
        })
    }
  }

  export const fetchOwnersList = (appId, callback=null, errorCallback=null) => {
    return (dispatch) => {
      return axios
        .get(`${API_PATHS.REQUEST_PAGE_API}/organizations/applications/${appId}/owners`)
        .then((res) => {
          dispatch({
            type: OWNERS_LIST,
            payload: {
              data: res.data,
              status: true
            },
          })
          if(callback) {
            callback(res.data);
          }
        })
        .catch((err) => {
          dispatch({ 
            type: CATCH_ERROR_APPS, 
            payload: { data: err.response?.data, status: false }
          })
          if(errorCallback) {
            errorCallback(err.response?.data);
          }
        })
    }
  }
  export const addOwner = (appId, newAddedOwners, callback=null, errorCallback=null) => {
    return (dispatch) => {
      return axios
        .post(`${API_PATHS.REQUEST_PAGE_API}/organizations/applications/${appId}/owners`,
          { owners: newAddedOwners },
        )
        .then((res) => {
          dispatch({
            type: ADD_OWNER,
            payload: {
              data: res.data,
              status: true
            },
          })
          if(callback) {
            callback(res.data);
          }
        })
        .catch((err) => {
          dispatch({ 
            type: CATCH_ERROR_APPS, 
            payload: { data: err.response?.data, status: false }
          })
          if(errorCallback) {
            errorCallback(err.response?.data);
          }
        })
    }
  }

  export const removeOwner = (appId, deletedOwners, callback=null, errorCallback=null) => {
    return (dispatch) => {
      return axios
        .put(`${API_PATHS.REQUEST_PAGE_API}/organizations/applications/${appId}/owners`, 
          { owners: deletedOwners }, // Payload with array of owners to remove
          {  headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        .then((res) => {
            console.log("delete_request ",res);
            dispatch({ 
              type: REMOVE_OWNER, 
              payload: { 
                data: { message: "Deleted Successfully" }, 
                status: true 
              }
            })
            if(callback) {
              callback({ message: "Deleted Successfully" });
            }
        })
        .catch((err) => {
          dispatch({ 
            type: CATCH_ERROR_APPS, 
            payload: { data: err.response?.data, status: false }
          })
          if(errorCallback) {
            errorCallback(err.response?.data);
          }
        })
    }
  }